import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ModelOfCartao, ModelOfCartaoLiberacao } from 'src/database';
import LoadingScreen from '../../components/LoadingScreen';
import { useListUnityCartaosController, } from '../../controllers/Cartao/ListaCartaoController'
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';
import { RadioButton } from 'primereact/radiobutton';
import { Divider } from 'primereact/divider';
import {
    faCar,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AutoComplete } from 'primereact/autocomplete';
import { InputMask } from 'primereact/inputmask';
import { dateToString } from 'src/utils/dateToString';

interface filteredProps {
    label: string;
    value?: string;
}

const CartaosList: React.FC = () => {
    const { getCartaoListController, handleCartaoListController } = useListUnityCartaosController();
    const { vehicles } = getCartaoListController
    const [valueVehicle, setValueVehicle] = useState('');
    const [filteredVehicle, setFilteredVehicle] = useState<filteredProps[]>([{ label: '', value: '' }]);

    if (getCartaoListController.loading) {
        return <LoadingScreen />
    };

    const searchVehicles = (event: any) => {
        let filteredVehicles;
        if (!event.query.trim().length) {
            filteredVehicles = [...vehicles];
        } else {
            filteredVehicles = vehicles.filter(unity => {
                return unity.label.toLowerCase().includes(event.query.toLowerCase());
            });
        }
        setFilteredVehicle(filteredVehicles);
    };

    const actionBodyTemplate = (cartao: ModelOfCartao) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success p-mr-2" onClick={() => handleCartaoListController.openEditDialog(cartao)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger" onClick={() => handleCartaoListController.openDeleteDialog(cartao)} />
                <Button className="p-button-rounded p-button-text p-button-danger" onClick={() => handleCartaoListController.openLiberacaoDialog(cartao)}>
                    <FontAwesomeIcon icon={faCar} />
                </Button>
            </React.Fragment>
        );
    };

    const statusBodyTemplate = (rowData: { STATUS: {} | null | undefined }) => {
        let status;
        let textStyle;
        if (rowData.STATUS === 1) {
            status = 'Não';
            textStyle = 'alert-message';
        }
        if (rowData.STATUS === 0) {
            status = 'Sim';
            textStyle = 'sucess-message';
        }
        return <span className={`tags ${textStyle}`}>{status}</span>;
    };

    const curingaBodyTemplate = (rowData: { CURINGA: {} | null | undefined }) => {
        let status;
        let textStyle;
        if (rowData.CURINGA === 1) {
            status = 'Não';
            textStyle = 'alert-message';
        }
        if (rowData.CURINGA === 0) {
            status = 'Sim';
            textStyle = 'sucess-message';
        }
        return <span className={`tags ${textStyle}`}>{status}</span>;
    };

    const editCartaoDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleCartaoListController.closeEditDialog} />
            <Button type="submit" label="Salvar" icon="pi pi-check" className="p-button-text" onClick={() => { getCartaoListController.formik.handleSubmit() }} />
        </React.Fragment>
    );

    const liberacaoCartaoDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleCartaoListController.closeLiberacaoDialog} />
            <Button type="submit" label="Salvar" icon="pi pi-check" className="p-button-text" onClick={() => { getCartaoListController.formikLiberacao.handleSubmit() }} />
        </React.Fragment>
    );

    const deleteCartaoDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleCartaoListController.closeDeleteDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text"
                onClick={() => {
                    getCartaoListController.selectedUnityCartao && handleCartaoListController.removeCartao(getCartaoListController.selectedUnityCartao)
                }}
            />
        </React.Fragment>
    );

    const leftCartaoToolbar = () => {
        return (
            <Link to="/cartaoForm">
                <Button label="Cadastrar cartao" icon="pi pi-plus" className="p-button-success p-mr-2" />
            </Link>
        );
    };

    const handleChangeCuringaSIM = (e: any) => {
        getCartaoListController.formik.setFieldValue("CURINGA", 0)
    };

    const handleChangeCuringaNAO = (e: any) => {
        getCartaoListController.formik.setFieldValue("CURINGA", 1)
    };

    const handleChangeStatusSIM = (e: any) => {
        getCartaoListController.formik.setFieldValue("STATUS", 0)
    };

    const handleChangeStatusNAO = (e: any) => {
        getCartaoListController.formik.setFieldValue("STATUS", 1)
    };


    const HEADER_DATAINICIOCARTAO = (rowData: ModelOfCartaoLiberacao) => {
        return (
            <React.Fragment>
                <span className="left-header">Data Início</span>
                {dateToString(rowData.DATAINICIO, 'br')}
            </React.Fragment>
        )
    }

    const HEADER_DATAFIMCARTAO = (rowData: ModelOfCartaoLiberacao) => {
        return (
            <React.Fragment>
                <span className="left-header">Data Fim</span>
                {dateToString(rowData.DATAFIM, 'br')}
            </React.Fragment>
        )
    }

    const actionBodyTemplateCartaoLiberacao = (CartaoLiberacao: ModelOfCartaoLiberacao) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success p-mr-2" onClick={() => handleCartaoListController.editCartaoLiberacao(CartaoLiberacao)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger" onClick={() => handleCartaoListController.openDeleteCartaoLiberacaoDialog(CartaoLiberacao)} />
            </React.Fragment>
        );
    };

    const deleteCartaoLiberacaoDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleCartaoListController.closeDeleteCartaoLiberacaoDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text"
                onClick={() => {
                    handleCartaoListController.selectedUnityCartaoLiberacao && handleCartaoListController.removeCartaoLiberacao(handleCartaoListController.selectedUnityCartaoLiberacao)
                }}
            />
        </React.Fragment>
    );


    return (
        <div>
            <Toast ref={getCartaoListController.toast} />
            <div className="p-card p-p-4 datatable-container">
                <Toolbar className="p-mb-4" left={leftCartaoToolbar}></Toolbar>

                <DataTable className="p-datatable-sm"
                    dataKey="ID" rowHover scrollable scrollHeight={'100%'}
                    value={getCartaoListController.unityCartaosData}>
                    <Column field="DESCRICAO" header="Descrição"></Column>
                    <Column field="IDENTIFICACAO" header="Identificação"></Column>
                    <Column body={curingaBodyTemplate} header="Curinga"></Column>
                    <Column body={statusBodyTemplate} header="Ativo"></Column>
                    <Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
                </DataTable>
            </div>

            <Dialog
                className="p-fluid"
                style={{ width: '750px' }}
                visible={getCartaoListController.liberacaoDialog}
                onHide={handleCartaoListController.closeLiberacaoDialog}
                onShow={() => (
                    getCartaoListController.formik.setFieldValue('ID', getCartaoListController.selectedUnityCartao?.ID),
                    getCartaoListController.formik.setFieldValue('DESCRICAO', getCartaoListController.selectedUnityCartao?.DESCRICAO),
                    getCartaoListController.getCartaoLiberacaos())
                    
                }
                footer={liberacaoCartaoDialogFooter}
                header={`Vincula cartão: ${getCartaoListController.selectedUnityCartao.DESCRICAO}`}
                modal
            >


                <div className='p-field p-col-12 p-md-12'>
                    <label htmlFor='descricao'>Veículo</label>
                    <AutoComplete
                        id='vehicle'
                        value={valueVehicle}
                        field='label'
                        onChange={e => {
                            console.log("Valor selecionado: ", e.value);
                            setValueVehicle(e.value.label);
                            getCartaoListController.formikLiberacao.setFieldValue(
                                'FT_VEICULO',
                                filteredVehicle.find(vehicle => {
                                    return e.value === vehicle.label;
                                })?.value || '',
                            );
                        }}
                        onSelect={e => {
                            setValueVehicle(e.value.label);
                            getCartaoListController.formikLiberacao.setFieldValue('FT_VEICULO', e.value.value);
                        }}
                        suggestions={filteredVehicle}
                        completeMethod={searchVehicles}
                        dropdown
                        placeholder='Selecione o veículo...'
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getCartaoListController.formikLiberacao.touched.FT_VEICULO && getCartaoListController.formikLiberacao.errors.FT_VEICULO,
                        'popup-form-inactive': !(getCartaoListController.formikLiberacao.touched.FT_VEICULO && getCartaoListController.formikLiberacao.errors.FT_VEICULO),
                    })}
                    >{getCartaoListController.formikLiberacao.errors.FT_VEICULO}</div>
                </div>

                <div className='p-grid p-col-12 p-md-12'>
                    <div className='p-col-6 p-md-6'>
                        <label htmlFor='descricao'>Data Inicio Liberação</label>
                        <InputMask
                            type={'text'}
                            mask='99/99/9999'
                            value={getCartaoListController.formikLiberacao.values.DATAINICIO}
                            onChange={e => {
                                getCartaoListController.formikLiberacao.setFieldValue('DATAINICIO', e.target.value);
                            }}
                            placeholder='__/__/____'
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getCartaoListController.formikLiberacao.touched.DATAINICIO && getCartaoListController.formikLiberacao.errors.DATAINICIO,
                            'popup-form-inactive': !(getCartaoListController.formikLiberacao.touched.DATAINICIO && getCartaoListController.formikLiberacao.errors.DATAINICIO),
                        })}
                        >{getCartaoListController.formikLiberacao.errors.DATAINICIO}</div>
                    </div>

                    <div className='p-col-6 p-md-6'>
                        <label htmlFor='descricao'>Data Fim Liberação</label>
                        <InputMask
                            type={'text'}
                            mask='99/99/9999'
                            value={getCartaoListController.formikLiberacao.values.DATAFIM}
                            onChange={e => {
                                getCartaoListController.formikLiberacao.setFieldValue('DATAFIM', e.target.value);
                            }}
                            placeholder='__/__/____'
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getCartaoListController.formikLiberacao.touched.DATAFIM && getCartaoListController.formikLiberacao.errors.DATAFIM,
                            'popup-form-inactive': !(getCartaoListController.formikLiberacao.touched.DATAFIM && getCartaoListController.formikLiberacao.errors.DATAFIM),
                        })}
                        >{getCartaoListController.formikLiberacao.errors.DATAFIM}</div>
                    </div>
                </div>
                <div className='p-col-6 p-md-6'>
                    <label>Veículo(s) vinculado ao cartão</label>
                </div>
                <Divider style={{ borderTop: '3px solid #191970', margin: '3px 0' }} />
                <div className="p-card p-p-4 datatable-container">

                    <DataTable className="p-datatable-sm"
                        dataKey="ID" rowHover scrollable scrollHeight={'100%'}
                        value={getCartaoListController.unityCartaosLiberacaoData}>
                        <Column style={{ width: '300px' }} field="DESCRICAOVEICULO" header="Veículo"></Column>
                        <Column field="DATAINICIO" header="Data Inicio" body={HEADER_DATAINICIOCARTAO}></Column>
                        <Column field="DATAFIM" header="Data Fim" body={HEADER_DATAFIMCARTAO}></Column>
                        <Column body={actionBodyTemplateCartaoLiberacao} bodyStyle={{ textAlign: 'right' }}></Column>
                        
                    </DataTable>
                </div>


            </Dialog>



            <Dialog
                className="p-fluid"
                style={{ width: '450px' }}
                visible={getCartaoListController.editDialog}
                onHide={handleCartaoListController.closeEditDialog}
                onShow={() => (
                    getCartaoListController.formik.setFieldValue('ID', getCartaoListController.selectedUnityCartao?.ID),
                    getCartaoListController.formik.setFieldValue('DESCRICAO', getCartaoListController.selectedUnityCartao?.DESCRICAO),
                    getCartaoListController.formik.setFieldValue('IDENTIFICACAO', getCartaoListController.selectedUnityCartao?.IDENTIFICACAO),
                    getCartaoListController.formik.setFieldValue('CURINGA', getCartaoListController.selectedUnityCartao?.CURINGA),
                    getCartaoListController.formik.setFieldValue('STATUS', getCartaoListController.selectedUnityCartao?.STATUS)
                )
                }
                footer={editCartaoDialogFooter}
                header={`Editar cartão: ${getCartaoListController.selectedUnityCartao.DESCRICAO}`}
                modal
            >
                <div className="p-field">
                    <label htmlFor="description">Descrição</label>
                    <InputText id="name" type="text" maxLength={150}
                        value={getCartaoListController.formik.values.DESCRICAO}
                        onChange={getCartaoListController.formik.handleChange('DESCRICAO')}
                        required
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getCartaoListController.formik.touched.DESCRICAO && getCartaoListController.formik.errors.DESCRICAO,
                        'popup-form-inactive': !(getCartaoListController.formik.touched.DESCRICAO && getCartaoListController.formik.errors.DESCRICAO),
                    })}
                    >{getCartaoListController.formik.errors.DESCRICAO}</div>
                </div>

                <div className="p-field">
                    <label htmlFor="description">Identificação (Número)</label>
                    <InputText id="name" type="text" maxLength={150}
                        value={getCartaoListController.formik.values.IDENTIFICACAO}
                        onChange={getCartaoListController.formik.handleChange('IDENTIFICACAO')}
                        required
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getCartaoListController.formik.touched.IDENTIFICACAO && getCartaoListController.formik.errors.IDENTIFICACAO,
                        'popup-form-inactive': !(getCartaoListController.formik.touched.IDENTIFICACAO && getCartaoListController.formik.errors.IDENTIFICACAO),
                    })}
                    >{getCartaoListController.formik.errors.IDENTIFICACAO}</div>
                </div>

                <label htmlFor='name'>Curinga</label>
                <div className='p-field p-mt-2'>
                    <div>
                        <RadioButton
                            inputId="simCuringa"
                            name="resposta"
                            value={getCartaoListController.formik.values.CURINGA}
                            checked={getCartaoListController.formik.values.CURINGA === 0}
                            onChange={handleChangeCuringaSIM}
                        />
                        <label htmlFor="simCuringa">Sim</label>
                    </div>
                    <div className=' p-mt-2'>
                        <RadioButton
                            inputId="naoCuringa"
                            name="resposta"
                            value={getCartaoListController.formik.values.CURINGA}
                            checked={getCartaoListController.formik.values.CURINGA === 1}
                            onChange={handleChangeCuringaNAO}
                        />
                        <label htmlFor="naoCuringa">Não</label>
                    </div>

                </div>

                <label htmlFor='name'>Ativo</label>
                <div className='p-field p-mt-2'>
                    <div>
                        <RadioButton
                            inputId="simStatus"
                            name="resposta"
                            value={getCartaoListController.formik.values.STATUS}
                            checked={getCartaoListController.formik.values.STATUS === 0}
                            onChange={handleChangeStatusSIM}
                        />
                        <label htmlFor="simStatus">Sim</label>
                    </div>
                    <div className=' p-mt-2'>
                        <RadioButton
                            inputId="naoStatus"
                            name="resposta"
                            value={getCartaoListController.formik.values.STATUS}
                            checked={getCartaoListController.formik.values.STATUS === 1}
                            onChange={handleChangeStatusNAO}
                        />
                        <label htmlFor="naoStatus">Não</label>
                    </div>

                </div>

            </Dialog>

            <Dialog
                style={{ width: '450px' }}
                visible={getCartaoListController.deleteDialog}
                onHide={handleCartaoListController.closeDeleteDialog}
                footer={deleteCartaoDialogFooter}
                header="Remover cartao"
                modal
            >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {getCartaoListController.selectedUnityCartao && <span>Você tem certeza que deseja deletar a cartao <b>{getCartaoListController.selectedUnityCartao.DESCRICAO}</b>?</span>}
                </div>
            </Dialog>

            <Dialog
                style={{ width: '450px' }}
                visible={getCartaoListController.deleteCartaoLiberacaoDialog}
                onHide={handleCartaoListController.closeDeleteCartaoLiberacaoDialog}
                footer={deleteCartaoLiberacaoDialogFooter}
                header="Remover máquina"
                modal
            >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {handleCartaoListController.selectedUnityCartaoLiberacao  && <span>Você tem certeza que deseja remover <b>{handleCartaoListController.selectedUnityCartaoLiberacao.DESCRICAOVEICULO}</b>?</span>}
                </div>
            </Dialog>
        </div>

    );
};

export default CartaosList;